import {
    DateService,
    DeviceIdService,
    IndexedDBService,
    Quote,
    UTMParams,
} from '@pulse/browser-shared';
import { PulseAttributeHint } from '@pulse/common';

export class AttributesCacheService {
    private attributesStorageKey = 'attributesStore';

    constructor(
        private indexedDBService: IndexedDBService,
        private quote: Quote,
        private deviceIdService: DeviceIdService,
        private dateService: DateService,
    ) {
        indexedDBService.connectDB();
    }

    async getCachedAttributes() {
        const cachedAttributes = await this.indexedDBService.getValue(
            this.attributesStorageKey,
            'attributes',
        );

        if (cachedAttributes !== undefined && cachedAttributes !== null) {
            return cachedAttributes;
        }

        return undefined;
    }

    async getCachedHints() {
        const cachedHints = await this.indexedDBService.getValue(
            this.attributesStorageKey,
            'hints',
        );

        if (cachedHints !== undefined && cachedHints !== null) {
            return cachedHints;
        }

        return undefined;
    }

    async cacheAttributes(attributes: UTMParams | undefined, attributesSent = false) {
        const freeSpace = await this.quote.quoteSize();
        const attributesSize = new TextEncoder().encode(
            JSON.stringify({
                id: 'attributes',
                attributes,
                attributesSent: false,
                did: this.deviceIdService.getDeviceId(),
                time: this.dateService.now(),
            }),
        ).length;
        const enoughSpace = freeSpace && freeSpace - attributesSize > 1000000;

        if (enoughSpace || freeSpace === null) {
            await this.indexedDBService.putValue(this.attributesStorageKey, {
                id: 'attributes',
                attributes,
                attributesSent,
                did: this.deviceIdService.getDeviceId(),
                time: this.dateService.now(),
            });
        } else {
            console.error('There is no enough space to store attributes');
        }
    }

    async cacheHints(hints: PulseAttributeHint, hintsSent = false) {
        const freeSpace = await this.quote.quoteSize();
        const attributesSize = new TextEncoder().encode(
            JSON.stringify({
                id: 'hints',
                hints,
                hintsSent: false,
                did: this.deviceIdService.getDeviceId(),
                time: this.dateService.now(),
            }),
        ).length;
        const enoughSpace = freeSpace && freeSpace - attributesSize > 1000000;

        if (enoughSpace || freeSpace === null) {
            await this.indexedDBService.putValue(this.attributesStorageKey, {
                id: 'hints',
                hints,
                hintsSent,
                did: this.deviceIdService.getDeviceId(),
                time: this.dateService.now(),
            });
        } else {
            console.error('There is no enough space to store attributes');
        }
    }

    async markSent(type: 'hints' | 'attributes') {
        if (type === 'hints') {
            const storedHints = await this.getCachedHints();

            if (storedHints) {
                this.cacheHints(storedHints.hints, true);
            }
        }
        if (type === 'attributes') {
            const storedAttributes = await this.getCachedAttributes();

            if (storedAttributes) {
                this.cacheAttributes(storedAttributes.attributes, true);
            }
        }
    }
}
